import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrTickIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M14.4958 3.50507C14.7691 3.77844 14.7691 4.22166 14.4958 4.49502L5.69309 13.2977L1.50581 9.11041C1.23244 8.83704 1.23244 8.39383 1.50581 8.12046C1.77917 7.84709 2.22239 7.84709 2.49576 8.12046L5.69309 11.3178L13.5058 3.50507C13.7792 3.23171 14.2224 3.23171 14.4958 3.50507Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrTickIconComponent;
